const firebaseConfig = {
  apiKey: 'AIzaSyBliXE0L5Ev_e1NVMc4oHHEOBgp75-skVw',
  authDomain: 'bbiyong-bbiyong.firebaseapp.com',
  projectId: 'bbiyong-bbiyong',
  storageBucket: 'bbiyong-bbiyong.appspot.com',
  messagingSenderId: '944206714058',
  appId: '1:944206714058:web:b19c3cc593f6c1cda65033',
  measurementId: 'G-1VNS1TY38X',
};

const firebaseVapidKey =
  'BNYCgj0oUS7RlPkawMTqMDh8vJORK0OJUEPvwwjN3cQg9cRq6qYymDzpsYFOW0BM-UY1wqvQoQm8Ed7nvPJhoL0';

export { firebaseConfig, firebaseVapidKey };
